import { Middlewares } from "@/app/shared/services/app-router/middlewares";
import Guard from "vue-router-multiguard";

export default [
  {
    path: '/documents/:documentType',
    name: 'Documents',
    component: () => import('./views/documents.vue'),
    meta: {
      title: 'Документы',
      wfPage: '652921c910bae02d8870dddc'
    }
  },
];
